__turbopack_context__.v({
  "rightPanel": "styles-module-scss-module__NSGIiG__rightPanel",
  "rightPanel__desktop": "styles-module-scss-module__NSGIiG__rightPanel__desktop",
  "rightPanel__greeting": "styles-module-scss-module__NSGIiG__rightPanel__greeting",
  "rightPanel__greetingBlock": "styles-module-scss-module__NSGIiG__rightPanel__greetingBlock",
  "rightPanel__hi": "styles-module-scss-module__NSGIiG__rightPanel__hi",
  "rightPanel__mobile": "styles-module-scss-module__NSGIiG__rightPanel__mobile",
  "rightPanel__name": "styles-module-scss-module__NSGIiG__rightPanel__name",
  "rightPanel__stepperWrap": "styles-module-scss-module__NSGIiG__rightPanel__stepperWrap",
  "rightPanel__stepperWrap_modHidden": "styles-module-scss-module__NSGIiG__rightPanel__stepperWrap_modHidden",
});
